/**
 * Data block: reads play-mode elapsed time from the TraceScene's
 * SystemValueProvider. Pure data node — no flow sockets, no target.
 * Output is pulled when a downstream execution node needs the value.
 *
 * Mirrors the `time.elapsed` system value available in `{expression}` bindings.
 */

import { FlowGraphBlock } from "@babylonjs/core/FlowGraph/flowGraphBlock";
import type { FlowGraphContext } from "@babylonjs/core/FlowGraph/flowGraphContext";
import type { IFlowGraphBlockConfiguration } from "@babylonjs/core/FlowGraph/flowGraphBlock";
import { RichTypeNumber } from "@babylonjs/core/FlowGraph/flowGraphRichTypes";
import type { TraceScene } from '../../../core/TraceScene';
import { TRACE_SCENE_VAR } from './traceContext';

export class TraceTimeBlock extends FlowGraphBlock {
    constructor(config?: IFlowGraphBlockConfiguration) {
        super(config);
        this.registerDataOutput("elapsed", RichTypeNumber);
    }

    public override _updateOutputs(context: FlowGraphContext): void {
        const traceScene = context._getGlobalContextVariable(TRACE_SCENE_VAR, null) as TraceScene | null;
        const elapsed = traceScene?.getSystemValues().getElapsed() ?? 0;
        this.getDataOutput("elapsed")!.setValue(elapsed, context);
    }

    public override getClassName(): string {
        return "TraceTimeBlock";
    }
}
